import Component from "../../../lib/component";

export const MessageConfig = {
    // componentTypeKey: "Message",
    baseHtmlClass: "member_offer_acceptor__msg",
    selector: ".member_offer_acceptor__msg",
};

export class Message extends Component {
    static get config() {
        return MessageConfig;
    }

    constructor(id_or_element, memberOfferAcceptor) {
        super({
            element: id_or_element,
            config: MessageConfig,
        });

        this.memberOfferAcceptor = memberOfferAcceptor;

        this.initialContent = this.element.innerHTML;
        this.content = null;

        const submission = this.memberOfferAcceptor.getLastSubmission();
        if (submission && submission.isAccepted()) this.setContent(`We've already sent an email to ${ submission.email }. Please check your inbox.`);

        this.render();
    }

    render() {
        this.element.innerHTML = this.getContent();
    }

    getContent() {
        if (this.content) {
            return this.content;
        } else {
            return this.initialContent;
        }
    }

    setContent(content) {
        this.content = content;
    }
}
